'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var handler = HANDLERS[action.type] || function () {
        return state;
    };
    return handler(action.payload, state);
};

var _OrganizationActions = require('../actions/OrganizationActions');

var OrganizationActions = _interopRequireWildcard(_OrganizationActions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _wixrestProperties = require('@wix/wixrest-properties');

var _wixrestProperties2 = _interopRequireDefault(_wixrestProperties);

var _Properties = require('@wix/wixrest-utils/dist/Properties');

var _Properties2 = _interopRequireDefault(_Properties);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    organization: null,
    topLevelOrganization: null,
    newOrganization: false
};

var HANDLERS = (0, _defineProperty3.default)({}, OrganizationActions.types.ORGANIZATION_LOAD, function (payload, state) {
    var organization = payload.organization,
        isOriginOrg = payload.isOriginOrg;

    var newOrganization = organization.title[organization.locale] === '[new]';

    return (0, _extends3.default)({}, state, {
        organization: migrateOrganization(organization),
        newOrganization: newOrganization,
        topLevelOrganization: state.topLevelOrganization || migrateOrganization(organization),
        isOriginOrg: isOriginOrg
    });
});

/**
 * Various organization migration tools
 */
function migrateOrganization(organization) {
    var migrated = _lodash2.default.cloneDeep(organization);

    if (!migrated.media) {
        migrated.media = {};
    }

    if (migrated.type === 'restaurant' && (migrated.deliveryInfos || []).length === 0) {
        migrated.deliveryInfos = [{ type: 'takeout', delayMins: 15, inactive: true }];
    }

    return migrated;
}